<script lang="ts">
	//Svelte
	import { createEventDispatcher } from 'svelte';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Design System Components
	import { Collapse, Stack, ListItem } from '@Shelly/shelly-design-system';
	//Helpers
	import { load_image_from } from 'src/helpers/interface_helpers';
	import type { AlarmDeviceStateType } from '../../list-helpers';
	// Types
	import type { Device } from 'src/types/Device';
	import type { ListItemProps } from '@Shelly/shelly-design-system/ListItem/ListItem.svelte';

	export let expanded = true;
	export let alarmDevicesGroup: AlarmDeviceStateType[] = [];
	export let title = '';
	export let groupExtraText: ListItemProps['extraText'] = {};
	export let showItemsActBtn = true;
	export let showItemsSubtitle = false;

	const dispatchDeviceClick = createEventDispatcher<{
		deviceClick: Device['id'];
	}>();

	const getDeviceAvatar = (device: Device) => ({
		image: device?.image
			? load_image_from(device?.image, device?.localImage ? '' : device?.server).replace(
					'thumb_',
					'',
				)
			: undefined,
		backgroundColor: device.backgroundColor ? device.backgroundColor : null,
		icon: device.icon,
		notification: null,
	});
</script>

{#if alarmDevicesGroup.length}
	<Collapse id="collapse-s8ippj7" {title} {expanded} on:click={() => (expanded = !expanded)}>
		<Stack gap="xs">
			{#each alarmDevicesGroup as deviceData}
				{@const device = $devices[deviceData.id]}
				{@const avatar = getDeviceAvatar(device)}
				{@const subtitle = showItemsSubtitle
					? `(${deviceData?.alarmList.map((a) => a._meta.name).join(', ')})`
					: ''}
				<ListItem
					actionBtn={showItemsActBtn}
					image={avatar.image}
					icon={avatar.icon}
					backgroundColor={avatar.backgroundColor}
					title={$devices[deviceData.id].name}
					{subtitle}
					extraText={groupExtraText}
					on:click={() => dispatchDeviceClick('deviceClick', device.id)}
				/>
			{/each}
		</Stack>
	</Collapse>
{/if}
